import Button from "../../components/ui/button";
import World from "../../assets/images/world.png";
import Coin from "../../assets/images/coin.png";
import MoneyHand from "../../assets/illustration/money-in-hand.png";
import Bill from "../../assets/illustration/bill.png";
import MoneyWallet from "../../assets/illustration/money-in-wallet.png";
import NoTransfer from "../../assets/icons/no-transfer-fee.svg";
import Instant from "../../assets/icons/instant-transfer.svg";
import Spend from "../../assets/icons/spend.svg";
import Card from "../../assets/images/fx-card.png";

import One from "../../assets/icons/how-it-works/1.svg";
import Two from "../../assets/icons/how-it-works/2.svg";
import Three from "../../assets/icons/how-it-works/3.svg";
import Signup from "../../assets/icons/how-it-works/sign-up.svg";
import GetVerified from "../../assets/icons/how-it-works/get-verified.svg";
import Access from "../../assets/icons/how-it-works/access-account.svg";
import Send from "../../assets/icons/how-it-works/send-money.svg";
import CreateCard from "../../assets/icons/how-it-works/create-card.svg";
import Pay from "../../assets/icons/how-it-works/pay-bills.svg";
import GetPaid from "../../assets/icons/how-it-works/get-paid.svg";

import HeroTag from "./components/HeroTag";
import Countries from "./components/Countries";
import YoutubePage from "./components/YoutubePage";
import HowItWorksCard from "./components/HowItWorksCard";

const HomePage = () => {
  return (
    <div className="pt-20">
      {/*  */}
      <header className="container mx-auto flex items-center justify-center p-3  py-10 text-[#231F20]">
        <div className="flex flex-col items-center  gap-5 md:w-[50%]">
          <h1 className="head text-center text-[50px] font-bold leading-[55px] ">
            Become Money Transfer Agent in Less Than Five Minutes.
          </h1>
          <h3 className="text-base font-medium md:px-10 text-center">
            With zero capital, help people send, recieve, and spend money in
            eight countries in Africa. You get paid while you do that.
          </h3>
          <div className="flex items-center gap-4">
            <Button
              backgroundColor="#C29500"
              label="Become an Agent"
              loading={false}
              onClick={() => {}}
              type="contained"
              color="white"
              rounded
            />
            <Button
              backgroundColor="#C295001A"
              label="See how it works"
              loading={false}
              onClick={() => {}}
              type="contained"
              color="#C29500"
              rounded
            />
          </div>
        </div>
      </header>
      {/*  */}
      <div className="container relative mx-auto flex items-center justify-center  pt-5 text-[#231F20]">
        <img src={World} alt="" />
        <img
          src={Coin}
          alt=""
          className="absolute animate-pulse duration-1000"
        />
      </div>
      {/*  */}
      <div className="md:flex text-[#231F20] bg-[#FFFDF6] h-fit hidden ">
        <div className="container mx-auto p-3 md:px-10">
          <div className="flex justify-between w-full">
            <HeroTag image={NoTransfer} text="No Transfer fees" />
            <HeroTag image={Instant} text="Instant Transfer (0.03 Seconds)" />
            <HeroTag image={Spend} text="Spend your money anywhere" />
          </div>
        </div>
      </div>
      {/*  */}
      <div className="container mx-auto flex items-center justify-center p-3  py-10 text-[#231F20]">
        <div className="flex flex-col items-center  gap-5 md:w-[50%]">
          <h1 className="head text-center text-3xl font-bold">
            Send & Receive Money Across Africa
          </h1>
          <h3 className="text-sm font-medium md:px-16 text-center leading-6">
            Without delays, and with zero charges, use FXKudi to send money in
            15 countries in and across Africa. Move your money freely without
            borders with FXKudi.
          </h3>
          <Button
            backgroundColor="#C29500"
            label="Get Started"
            loading={false}
            onClick={() => {}}
            type="contained"
            color="white"
            rounded
            long
          />
        </div>
      </div>
      {/*  */}
      <div className="overflow-hidden relative flex items-center justify-center h-[60px] pb-5 container mx-auto ">
        <Countries />
      </div>
      {/*  */}
      <div className="container mx-auto pt-7 md:px-12">
        {/* <img
          src={People}
          alt=""
          className="border-t-[10px] border-x-[10px] md:rounded-t-[30px]"
        /> */}
        <YoutubePage />
      </div>
      {/*  */}
      <div className="bg-virtualBg bg-cover bg-center bg-no-repeat">
        <div className="container mx-auto flex flex-col md:flex-row py-5 md:py-0 items-center gap-5">
          <div className="flex flex-col gap-5 items-start text-white p-4 md:p-10 md:py-20 md:w-1/2">
            <h1 className="head text-3xl font-bold">Create Dollar Card</h1>
            <h3 className="text-sm leading-7">
              Virtual dollar cards are powerful because it helps people connect
              to endless possiblities. Ear money per card you create. As an
              agent, you'll be able to create cards that does not require
              monthly maintenance fees, allowing customers to shop online, pay
              streaming, for rides, and use for many other online global and
              local payment needs. You're giving people the freedom to pay
              online.
            </h3>
            <Button
              backgroundColor="#C29500"
              label="Learn More"
              loading={false}
              onClick={() => {}}
              type="contained"
              color="white"
              rounded
              long
            />
          </div>
          <div className=" flex items-center justify-center md:w-1/2">
            <img src={Card} alt="" className="md:w-[400px]" />
          </div>
        </div>
      </div>
      {/*  */}
      <div className="bg-sendBg bg-cover bg-center bg-no-repeat">
        <div className="container mx-auto flex flex-col-reverse md:flex-row pt-5 md:py-0 items-center gap-5">
          <div className="md:w-1/2">
            <img src={MoneyHand} alt="" className="" />
          </div>
          <div className="flex flex-col gap-5 items-start text-white p-4 md:p-10 md:py-20 md:w-1/2">
            <h1 className="head text-3xl font-bold">Send & Receive Money</h1>
            <h3 className="text-sm leading-7">
              You're the gateway to helping people experience hassle-free
              cross-border transactions with FXKudi. Send money instantly to
              over eight countries across Africa, all with zero transaction
              fees. With FXKudi, your money moves as freely as you do — secure,
              swift, and borderless.
            </h3>
            <Button
              backgroundColor="#C29500"
              label="Learn More"
              loading={false}
              onClick={() => {}}
              type="contained"
              color="white"
              rounded
              long
            />
          </div>
        </div>
      </div>
      {/*  */}
      <div className="bg-instantBg bg-cover bg-center bg-no-repeat">
        <div className="container mx-auto flex flex-col md:flex-row py-5 md:py-0 items-center gap-5">
          <div className="flex flex-col gap-5 items-start text-white p-4 md:p-10 md:py-20 md:w-1/2">
            <h1 className="head text-3xl font-bold">
              Free Virtual Wallet For Your
              <br className="hidden md:block" /> Transfer Needs.
            </h1>
            <h3 className="text-sm leading-7">
              You sure need a way to do all your transactions in one place. As
              you send money to other countries for yourself and others, virtual
              wallets help you exchange one currency to another. As you do that
              on repeat, you get paid commission each time.
            </h3>
            <Button
              backgroundColor="#C29500"
              label="Learn More"
              loading={false}
              onClick={() => {}}
              type="contained"
              color="white"
              rounded
              long
            />
          </div>
          <div className="md:w-1/2 p-3 md:pl-20">
            <img src={MoneyWallet} alt="" className="" />
          </div>
        </div>
      </div>
      {/*  */}
      <div className="bg-sendBg bg-cover bg-center bg-no-repeat">
        <div className="container mx-auto flex flex-col-reverse md:flex-row pt-5 md:py-0 items-center gap-5">
          <div className="md:w-1/2">
            <img src={Bill} alt="" className="" />
          </div>
          <div className="flex flex-col gap-5 items-start text-white p-4 md:p-10 md:py-20 md:w-1/2">
            <h1 className="head text-3xl font-bold">
              Gateway for Bills Payment
            </h1>
            <h3 className="text-sm leading-7">
              Do bills payment by helping people pay for Cable TV (DSTV), buy
              airtime and pay for internet subscriptions all at no extra fees
              and instantly from anywhere, anytime.
            </h3>
            <Button
              backgroundColor="#C29500"
              label="Learn More"
              loading={false}
              onClick={() => {}}
              type="contained"
              color="white"
              rounded
              long
            />
          </div>
        </div>
      </div>
      {/*  */}
      <div className="">
        <div className="container mx-auto flex flex-col gap-16 py-12 px-4 md:px-8">
          <div className="flex flex-col items-center">
            <h1 className="head text-xl font-bold">How It Works</h1>
            <h3 className="font-medium text-base">
              Learn how it works in few easy steps
            </h3>
          </div>
          <div className="flex flex-col gap-14">
            <div className="relative mt-12">
              <img src={One} alt="" className="absolute bottom-0" />
              <h1 className="head text-3xl font-bold">Become An Agent</h1>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <HowItWorksCard
                heading="Sign Up"
                icon={Signup}
                main="In few, easy steps you can sign up for an account with FXKudi and become aan Agent."
              />
              <HowItWorksCard
                heading="Get Verified"
                icon={GetVerified}
                main="By providing the few required documents, you can get verified instantly and gain full access to the App."
              />
              <HowItWorksCard
                heading="Access Your Account"
                icon={Access}
                main="After getting Verified, you can now send or receive money, generate dollar cards and pay bills."
              />
            </div>
          </div>
          <div className="flex flex-col gap-14">
            <div className="relative mt-12">
              <img src={Two} alt="" className="absolute bottom-0" />
              <h1 className="head text-3xl font-bold">Start Transacting</h1>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <HowItWorksCard
                heading="Send Money"
                icon={Send}
                main="Send money instantly to over eight countries across Africa, all with zero transaction fees. With FXKudi, your money moves as freely as you do - secure, swift and borderlesss."
              />
              <HowItWorksCard
                heading="Create Dollar Card"
                icon={CreateCard}
                main="As an agent, you’ll be able to create cards that does not require monthly maintenance fees, allowing them to shop online, pay for streaming, for rides, and maintain other online global and local payment needs."
              />
              <HowItWorksCard
                heading="Pay Bills"
                icon={Pay}
                main="DO bills payment by helping people pay for cable TV (DSTV), buy airtime and pay for internet subscriptions all at no extra fees and instantly from anywhere, anytime."
              />
            </div>
          </div>
          <div className="flex flex-col gap-14">
            <div className="relative mt-12">
              <img src={Three} alt="" className="absolute bottom-0" />
              <h1 className="head text-3xl font-bold">Earn on the go</h1>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <HowItWorksCard
                heading="Get Paid For Transacting"
                icon={GetPaid}
                main="As you send or receive money, create cards and pay bills for customers, you are rewarded for each transactions you make monies you help receive"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
